// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__EMAqZ","head":"styles_head__qNCad","buttonGroup":"styles_buttonGroup__0AWin","button":"styles_button__a9Wla","buttonTabs":"styles_buttonTabs__6eEMs"};